// DealNotFound (Phase 55 Plan 39): shown for a /transactions/<id> that resolves
// to nothing (missing, migrated, or hidden). Mirrors the contact not-found state.
import React from 'react';
import { Button } from '../../ui/primitives';

// DealLoading: the deal route's loading state for a deal that cannot be
// confirmed missing yet (a parent owner's id, while the team read in
// useTawDealLookup is still in flight). Never an empty editable form, never a
// false "not found".
export function DealLoading() {
    return (
        <div
            className="h-full flex flex-1 items-center justify-center p-10"
            role="status"
            aria-busy="true"
            data-testid="deal-loading"
        >
            <div aria-hidden="true" className="h-6 w-6 animate-spin rounded-full border-2 border-[color:var(--color-accent)] border-t-transparent" />
            <span className="sr-only">Loading deal…</span>
        </div>
    );
}

export default function DealNotFound({ onBack }) {
    return (
        <div className="h-full flex items-center justify-center px-5" data-testid="deal-not-found">
            <div className="max-w-md text-center">
                <h1 className="text-lg font-semibold text-[color:var(--text-primary)]">
                    We couldn&apos;t find that deal
                </h1>
                <p className="mt-2 text-sm text-[color:var(--text-muted)]">
                    It may have been deleted or archived, or the link is out of date. Go back to your transactions to find it.
                </p>
                <div className="mt-5 flex justify-center">
                    <Button
                        as="a"
                        href="/transactions"
                        variant="secondary"
                        onClick={(e) => { e.preventDefault(); onBack(); }}
                    >
                        Back to transactions
                    </Button>
                </div>
            </div>
        </div>
    );
}
